import { HttpService } from '@/services/httpService'

type ProductPriceResponse = {
    sku: string
    price: number
    discountPrice?: number
    discountPriceStatus?: number
}

type ProductPriceBulkResponse = ProductPriceResponse[]

const PRICE_ENDPOINT = '/common/product-price/find-product/bulk'

const getBulkPrices = async (
    skus: string[]
): Promise<ProductPriceBulkResponse> => {
    if (!skus.length) return []
    return HttpService.Post<ProductPriceBulkResponse>(PRICE_ENDPOINT, { skus })
}

export const productPriceService = {
    getBulkPrices
}
